let store = null;
export function initializeRegisterModule(_store) {
	store = _store;
}
export function registerModule(moduleName, _module) {
	store.registerModule(moduleName, _module);
	if (_module.plugins) {
		_module.plugins.forEach(plugin => {
			plugin(store);
		});
	}
}
